export const getProductURL = (materialId: string, slug?: string) => {
  if (!materialId) return '#';
  return `/dp/${materialId}/${slug ?? ''}`;
};

export const getCategoryURL = (categoryId?: string) => `/c/${categoryId}`;

export const getStoreURL = (storeId?: string) => `/s/${storeId}`;

export const getSubCategoryURL = (categoryId?: string, subCategoryId?: string) =>
  `/c/${categoryId}/${subCategoryId}`;

export const getSearchURL = (searchKey: string) => `/search?q=${searchKey}`;

export const getOrderDetailURL = (orderItemId: string) => `/ecom/order/${orderItemId}`;
export const getBlogCategoryURL = (categoryId: string) => {
  if (categoryId === 'All') return '/blog';
  return `/blog/category/${categoryId}`;
};

export const getBlogURL = (blogId: string) => `/blog/${blogId}`;

export const getAuthorizedCenterURL = (cityId: string, pincode: string, id: number) =>
  `/authorized-center/${cityId}-${pincode}/${id}`;

export const getURLWithQueryParams = (
  endpoint: string,
  queryParams?: Record<string, any>,
): string => {
  if (!queryParams || !Object.keys(queryParams).length) return endpoint;

  const queryString = Object.entries(queryParams)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');

  return `${endpoint}${endpoint.includes('?') ? '&' : '?'}${queryString}`;
};

export const getAssetDetailURL = (assetId: string) => `/amc/my-device/${assetId}`;

export const getAssetServiceBookingURL = (assetId: string) => `/services/${assetId}/book`;
export const getServiceTrackingURL = (assetId: string, reqId: string) =>
  `/statusTracking?assetid=${assetId}&reqId=${reqId}`;
